import { DESCRIPTION_COPY_LIMITS, TITLE_COPY_LIMITS } from "../copy-policy";
export const playgroundCardSchema = {
    componentId: "PlaygroundCard",
    scalarSlots: [
        { key: "heading", ...TITLE_COPY_LIMITS, label: "Heading", type: "text" },
        {
            key: "subheading",
            ...DESCRIPTION_COPY_LIMITS,
            label: "Subheading",
            type: "textarea",
        },
    ],
    mediaSlots: [
        // Single-target BY CONTRACT, deliberately: place-image-in-block-slot's
        // picked-not-another example needs two photos framed at the SAME single
        // size, indistinguishable by cropId — a second declared size would let a
        // later session defuse it by framing the photos apart.
        {
            key: "icon",
            label: "Icon",
            targets: [{ width: 96, height: 96, aspectRatio: "1:1" }],
        },
    ],
};
//# sourceMappingURL=playground-card.js.map